@if (showFooterLinks) {
  <div class="footer-app-links-container content-width-basic">
    <div class="app-store-links-container">
      <div class="title">{{ 'footer.appStore.title' | translate }}</div>
      <div class="description">{{ 'footer.appStore.description' | translate }}</div>
      <div class="app-store-links">
        <a [href]="links.ios" target="_blank" class="app-store-link">
          <img class="ios" src="assets/img/apple-link.svg" alt="Apple Store" />
        </a>
        <a [href]="links.android" target="_blank" class="app-store-link">
          <img class="android" src="assets/img/google-play-link.svg" alt="Google Play Store" />
        </a>
      </div>
    </div>
  </div>
  <div class="footer-user-info-container content-width-basic">
    <div class="contact-us">
      <div class="info-label">{{ 'footer.userInfo.contactUs' | translate }}</div>
      <div class="info-value">
        <a [attr.href]="'tel:' + ('footer.userInfo.phone' | translate)">{{ 'footer.userInfo.phone' | translate }}</a>
      </div>
      @if (hotlineAvailability()) {
        <div class="info-label">
          <liberro-hotline-availability
            [hotlineAvailability]="hotlineAvailability()!"
          ></liberro-hotline-availability>
        </div>
      }
      <div class="info-value">
        <a [attr.href]="'mailto:' + ('footer.userInfo.email' | translate)">{{ 'footer.userInfo.email' | translate }}</a>
      </div>
    </div>
    <liberro-basic-layout-footer-links></liberro-basic-layout-footer-links>
  </div>
}

<div
  class="footer-base content-width-basic"
  [ngClass]="{
    'highlighted-top-border': showFooterLinks,
    'footer-base--hamburger-mobile-panel': variant === 'mobile-hamburger',
  }"
>
  <div class="logo-container">
    <div class="logo"></div>
    <span class="copyright">{{ copyrightText }}</span>
    @if(deviceService.isNativePlatform) {
      <span class="native-version">{{ 'footer.appVersion' | translate }} {{ appVersion }}</span>
    }
  </div>
  <div class="social-btns" [class.flex-end]="variant === 'mobile-hamburger'">
    @if (variant !== 'mobile-hamburger') {
      <a nz-button nzType="link" [nzDanger]="true" (click)="triggerShowCookieSettings()" class="cookie-link">
        {{ 'global.button.cookieSettings' | translate }}
      </a>
    }
    <div>
      <a [href]="links.facebook" target="_blank">
        <svg-icon
          [src]="'assets/icons/fb-circle.svg'"
        ></svg-icon>
      </a>
      <a [href]="links.linkedin" target="_blank">
        <svg-icon
          [src]="'assets/icons/linkedin-circle.svg'"
        ></svg-icon>
      </a>
    </div>
  </div>
</div>
